import { Component } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
    selector: 'cl-status-change-decision-notes-modal',
    standalone: false,
    templateUrl: './status-change-decision-notes-modal.component.html',
    styleUrl: './status-change-decision-notes-modal.component.less',
})
export class StatusChangeDecisionNotesModalComponent {
    decisionNotes: string;
    decisionNoteNameLv: string = 'Iemesls';

    constructor(
        private modal: NzModalRef,
        private messageService: NzMessageService,
    ) {}

    submitAndReturn(): void {
        if (!this.decisionNotes?.trim()) {
            this.messageService.warning(`${this.decisionNoteNameLv} ir jānorāda obligāti!`);
            return;
        }

        this.modal.close(this.decisionNotes);
    }

    cancel(): void {
        this.modal.destroy();
    }
}
